import script from "./PlaybackChannelSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlaybackChannelSummary.vue?vue&type=script&lang=ts&setup=true"

import "./PlaybackChannelSummary.vue?vue&type=style&index=0&id=c1b531e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1b531e8"]])

export default __exports__